import { Input, DatePicker, Tooltip, Grid } from "antd";
import { DownloadOutlined, LoadingOutlined } from "@ant-design/icons";
import { searchIcon } from "svgs";
import moment, { Moment } from "moment";

interface TripsHeaderProps {
  selectedDate: Moment | null;
  onDateChange: (date: Moment | null, dateString: string) => void;
  searchText: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDownloadCsv: () => void;
  hasDownloadData: boolean;
  isDownloading?: boolean;
}

export default function TripsHeader({
  selectedDate,
  onDateChange,
  searchText,
  onSearchChange,
  onDownloadCsv,
  hasDownloadData,
  isDownloading = false,
}: TripsHeaderProps) {
  const { useBreakpoint } = Grid;
   const screens = useBreakpoint();
  const isMobile = !screens.sm;

  const tooltipTitle = isDownloading
    ? "Downloading Trips..."
    : hasDownloadData
      ? "Download Trips"
      : "Download Trips";

  const iconStyle = {
    fontSize: "20px",
    cursor: isDownloading ? "not-allowed" : "pointer",
    padding: "5px 18px",
    color: isDownloading ? "#ccc" : "inherit",
  } as const;

  return (
    <div
      className="common-header"
      style={{
        display: "flex",
        justifyContent: "space-between", // Space between left and right groups
        alignItems: "center", // Vertically center items
        width: "100%", // Ensure the header takes full width
      }}
    >
      <div style={{ flex: 1, maxWidth: "300px"}}>
        <Input
          className="search-box filter-search --standard"
          placeholder="Search Trips..."
          value={searchText}
          prefix={searchIcon}
          onChange={onSearchChange}
          style={{ width: "100%" , height: "35px"}}
        />
      </div>
    {/* {isMobile && ( <h1 style={{ flex: 1,paddingTop: "6px", alignItems: "left" }}>Trips</h1>)} */}
      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "16px", // Space between date picker and download icon
          marginRight: "20px", // Space from the right edge
        }}
      > */}
        {/* <DatePicker
          onChange={onDateChange}
          value={selectedDate}
          format="DD-MM-YYYY"
          disabledDate={(current) => current && current > moment().endOf("day")}
        /> */}
         {/* <div
          style={{
            width: "1px",
            height: "20px",
            background: "#e0e0e0",
            margin: "0 1px",
          }}
        /> */}
          <div style={{ flex: 1 }} />

      {/* Right side: Download button */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
       <Tooltip title={tooltipTitle}>
          {isDownloading ? (
            <LoadingOutlined style={iconStyle} />
          ) : (
            <DownloadOutlined style={iconStyle} onClick={onDownloadCsv} />
          )}
        </Tooltip>
      </div>
    </div>
  );
}